/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsListForPackGoodsForPackVo } from './GoodsListForPackGoodsForPackVo';
import {
    GoodsListForPackGoodsForPackVoFromJSON,
    GoodsListForPackGoodsForPackVoFromJSONTyped,
    GoodsListForPackGoodsForPackVoToJSON,
    GoodsListForPackGoodsForPackVoToJSONTyped,
} from './GoodsListForPackGoodsForPackVo';

/**
 * 
 * @export
 * @interface GoodsListForPackVo
 */
export interface GoodsListForPackVo {
    /**
     * 订单编号
     * @type {string}
     * @memberof GoodsListForPackVo
     */
    orderCode?: string;
    /**
     * 用户ID
     * @type {number}
     * @memberof GoodsListForPackVo
     */
    userId?: number;
    /**
     * 用户名
     * @type {string}
     * @memberof GoodsListForPackVo
     */
    userName?: string;
    /**
     * 用户编码
     * @type {string}
     * @memberof GoodsListForPackVo
     */
    userCode?: string;
    /**
     * 请求类型
     * @type {number}
     * @memberof GoodsListForPackVo
     */
    requestType?: number;
    /**
     * 订单状态
     * @type {number}
     * @memberof GoodsListForPackVo
     */
    orderStatus?: number;
    /**
     * 仓库ID
     * @type {number}
     * @memberof GoodsListForPackVo
     */
    warehouseId?: number;
    /**
     * 纸箱唛头号前缀
     * @type {string}
     * @memberof GoodsListForPackVo
     */
    boxMarknoPrefix?: string;
    /**
     * 托盘唛头号前缀
     * @type {string}
     * @memberof GoodsListForPackVo
     */
    palletMarknoPrefix?: string;
    /**
     * 国际运输方式ID
     * @type {number}
     * @memberof GoodsListForPackVo
     */
    internationalTransportMethodId?: number;
    /**
     * 运输方式韩文名
     * @type {string}
     * @memberof GoodsListForPackVo
     */
    transportMethodNameKr?: string;
    /**
     * 收货人韩文名
     * @type {string}
     * @memberof GoodsListForPackVo
     */
    receiverNameKr?: string;
    /**
     * 包装状态
     * @type {number}
     * @memberof GoodsListForPackVo
     */
    packageStatus?: number;
    /**
     * 包装作业商品基线版本；保存包装明细时须原样传回，用于识别打开页面后的商品变化
     * @type {string}
     * @memberof GoodsListForPackVo
     */
    packingGoodsVersion?: string;
    /**
     * 订单当前所在国家ID
     * @type {number}
     * @memberof GoodsListForPackVo
     */
    orderCurrentNationId?: number;
    /**
     * 订单历史镜像id
     * @type {number}
     * @memberof GoodsListForPackVo
     */
    beforeErrorProcessOrderId?: number;
    /**
     * 返送处理方式 1废弃 2韩国库存 3韩国快递件 4橙火入仓一般快递 5橙火入仓官方揽收快递 6橙火入仓官方揽收托盘
     * @type {number}
     * @memberof GoodsListForPackVo
     */
    returnFromCoupangMethod?: number;
    /**
     * 商品列表
     * @type {Array<GoodsListForPackGoodsForPackVo>}
     * @memberof GoodsListForPackVo
     */
    goodsForPackVOList?: Array<GoodsListForPackGoodsForPackVo>;
}

/**
 * Check if a given object implements the GoodsListForPackVo interface.
 */
export function instanceOfGoodsListForPackVo(value: object): value is GoodsListForPackVo {
    return true;
}

export function GoodsListForPackVoFromJSON(json: any): GoodsListForPackVo {
    return GoodsListForPackVoFromJSONTyped(json, false);
}

export function GoodsListForPackVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoodsListForPackVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'boxMarknoPrefix': json['boxMarknoPrefix'] == null ? undefined : json['boxMarknoPrefix'],
        'palletMarknoPrefix': json['palletMarknoPrefix'] == null ? undefined : json['palletMarknoPrefix'],
        'internationalTransportMethodId': json['internationalTransportMethodId'] == null ? undefined : json['internationalTransportMethodId'],
        'transportMethodNameKr': json['transportMethodNameKr'] == null ? undefined : json['transportMethodNameKr'],
        'receiverNameKr': json['receiverNameKr'] == null ? undefined : json['receiverNameKr'],
        'packageStatus': json['packageStatus'] == null ? undefined : json['packageStatus'],
        'packingGoodsVersion': json['packingGoodsVersion'] == null ? undefined : json['packingGoodsVersion'],
        'orderCurrentNationId': json['orderCurrentNationId'] == null ? undefined : json['orderCurrentNationId'],
        'beforeErrorProcessOrderId': json['beforeErrorProcessOrderId'] == null ? undefined : json['beforeErrorProcessOrderId'],
        'returnFromCoupangMethod': json['returnFromCoupangMethod'] == null ? undefined : json['returnFromCoupangMethod'],
        'goodsForPackVOList': json['goodsForPackVOList'] == null ? undefined : ((json['goodsForPackVOList'] as Array<any>).map(GoodsListForPackGoodsForPackVoFromJSON)),
    };
}

export function GoodsListForPackVoToJSON(json: any): GoodsListForPackVo {
    return GoodsListForPackVoToJSONTyped(json, false);
}

export function GoodsListForPackVoToJSONTyped(value?: GoodsListForPackVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCode': value['orderCode'],
        'userId': value['userId'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'requestType': value['requestType'],
        'orderStatus': value['orderStatus'],
        'warehouseId': value['warehouseId'],
        'boxMarknoPrefix': value['boxMarknoPrefix'],
        'palletMarknoPrefix': value['palletMarknoPrefix'],
        'internationalTransportMethodId': value['internationalTransportMethodId'],
        'transportMethodNameKr': value['transportMethodNameKr'],
        'receiverNameKr': value['receiverNameKr'],
        'packageStatus': value['packageStatus'],
        'packingGoodsVersion': value['packingGoodsVersion'],
        'orderCurrentNationId': value['orderCurrentNationId'],
        'beforeErrorProcessOrderId': value['beforeErrorProcessOrderId'],
        'returnFromCoupangMethod': value['returnFromCoupangMethod'],
        'goodsForPackVOList': value['goodsForPackVOList'] == null ? undefined : ((value['goodsForPackVOList'] as Array<any>).map(GoodsListForPackGoodsForPackVoToJSON)),
    };
}

